import { styled } from '@mui/material/styles';
import { Menu } from '@mui/material';

export const NavMenu = styled(Menu)({
  '& .MuiPaper-root': {
    padding: '0px !important',
    display: 'flex !important',
    flexDirection: 'column !important',
    '& .MuiButtonBase-root': {
      display: 'flex',
      justifyContent: 'flex-start',
      padding: '6px 16px !important',
    },
  },
});

export const navButtonStyles = {
  padding: '.5rem 1rem !important',
  color: 'black !important',
  fontWeight: 'normal !important',
  textTransform: 'none !important',
  borderRadius: '0 !important',
};

export const navButtonActiveStyles = {
  borderBottom: '3px solid #0075BF !important',
  paddingBottom: 'calc(.5rem - 3px) !important',
};

export const menuItemStyles = {
  padding: '6px 16px !important',
  display: 'flex',
  justifyContent: 'flex-start',
};

export const MobileMenuItemStyle = {
  display: 'flex !important',
  padding: '8px 16px !important',
  flexGrow: '0',
};

// The bar itself is opaque, not just the toolbar inside it. A transparent sticky bar
// relies on its child covering every pixel of it — any height the toolbar does not fill
// lets scrolled content show through the header.
export const appBarStyles = {
  color: 'black !important',
  top: '0',
  background: 'white !important',
  boxShadow: 'none !important',
};

export const toolbarStyles = {
  height: '88px',
  display: 'flex',
  justifyContent: 'space-between',
  background: 'white',
  boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
};

export const navigationMenuStyles = {
  width: 'auto',
  height: '100%',
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
};

export const navigationMobileMenuStyles = {
  width: 'auto',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  alignItems: 'space-around',
};

export const StaticHeaderContentStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
};

export const StaticHeaderContentImageStyles = {
  height: '1.25em',
  width: '1.25em',
  filter: 'invert(100%)',
  marginRight: '0.75em',
};

export const UserActionsStyles = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  gap: 1,
  color: 'black',
};

export const navigationTopMenuSpan = {
  background: '#292929',
  border: 'none',
  height: '3px',
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '0',
  transition: 'all .35s ease',
};

export const navigationMiddleMenuSpan = {
  background: '#292929',
  border: 'none',
  height: '3px',
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '0',
  transition: 'all .35s ease',
};

export const navigationBottomMenuSpan = {
  background: '#292929',
  border: 'none',
  height: '3px',
  width: '100%',
  position: 'absolute',
  top: '50%',
  left: '0',
  transition: 'all .35s ease',
};

export const staticHeaderContentSupportContainer = {
  background: '#0075BF',
  color: 'white',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: '600',
};

// The three header controls (search, apps, user menu) share one border, radius and hover
// so the cluster reads as a single set. HEADER_CONTROL_HEIGHT keeps them on a common
// baseline: the user trigger is a pill sized by its content, the other two are circles,
// and only a fixed height stops them disagreeing by a pixel or two.
const HEADER_CONTROL_HEIGHT = 44;

const headerControlBase = {
  border: '1px solid rgba(0, 0, 0, 0.23)',
  color: 'black',
  userSelect: 'none',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.04)',
  },
};

// Circular icon control — search and apps. Square footprint so the 9999px radius renders
// a true circle rather than a lozenge.
export const headerIconButtonStyles = {
  ...headerControlBase,
  width: HEADER_CONTROL_HEIGHT,
  height: HEADER_CONTROL_HEIGHT,
  borderRadius: '9999px',
  '& .MuiSvgIcon-root': {
    fontSize: '1.25rem',
  },
};

// Pill-shaped user-menu trigger: bordered, rounded, identity + chevron. Mirrors the
// Customer Portal header trigger so the two shells read as one product.
export const userMenuTriggerStyles = {
  ...headerControlBase,
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  padding: '6px 16px',
  height: HEADER_CONTROL_HEIGHT,
  borderRadius: '9999px',
  textAlign: 'left',
};

// Drawer variant of the search trigger. The drawers give search a full-width row, so a
// 44px circle there would read as a stray dot against the nav list; this keeps the
// footprint the input had while still being a button that opens the modal.
export const drawerSearchTriggerStyles = {
  ...headerControlBase,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '12px',
  width: '100%',
  height: HEADER_CONTROL_HEIGHT,
  margin: '1em 0',
  padding: '0 16px',
  borderRadius: '9999px',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '1rem',
};

// Menus anchored to the header controls: clear of the trigger rather than flush against
// it, so the open menu reads as a separate surface.
export const headerMenuPaperStyles = {
  mt: 1,
  minWidth: 220,
  borderRadius: 2,
  boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)',
};
